"use strict";

export default {
  NEU: "d1aff898-8bf6-46b0-9864-08eec1ee5573",
  EINGEREICHT: "95c6acaf-fffa-4389-a960-1fb80f14501a",
  GEPRUEFT: "09e98cbc-92ed-424a-9a9f-0c8d25428382",
};
